export const getToken = () => localStorage.getItem('token');
export const setToken = (token) => localStorage.setItem('token', token);

export const getIsLoggedIn = () => localStorage.getItem('isLoggedIn') === 'true';
export const setIsLoggedIn = (value) => localStorage.setItem('isLoggedIn', value ? 'true' : 'false');

export const getUserId = () => localStorage.getItem('userId');
export const setUserId = (id) => localStorage.setItem('userId', id);

export const getUserEmail = () => localStorage.getItem('userEmail');
export const setUserEmail = (email) => localStorage.setItem('userEmail', email);

export const getCurrentThreadId = () => localStorage.getItem('current_thread_id');
export const setCurrentThreadId = (id) => localStorage.setItem('current_thread_id', id);

export const getCurrentHistoryId = () => localStorage.getItem('current_history_id');
export const setCurrentHistoryId = (id) => localStorage.setItem('current_history_id', id);

export const getHasVisitedWorkspace = () => localStorage.getItem('hasVisitedWorkspace') === 'true';
export const setHasVisitedWorkspace = (value) => localStorage.setItem('hasVisitedWorkspace', value ? 'true' : 'false');

export const getAdminDelegateToken = () => localStorage.getItem('adminDelegateToken');
export const setAdminDelegateToken = (token) => localStorage.setItem('adminDelegateToken', token);

export const getTheme = () => localStorage.getItem('theme') || 'dark';
export const setTheme = (theme) => localStorage.setItem('theme', theme);

export const clearAppStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userId');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('current_thread_id');
  localStorage.removeItem('current_history_id');
  localStorage.removeItem('hasVisitedWorkspace');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('sub');
  localStorage.removeItem('lastTokenRefresh');
};

export const clearAllStorage = () => {
  localStorage.clear();
};
